import { SafeUrl } from "@angular/platform-browser";
import { BaseActorModel } from "./actors";

export class BaseDocumentModel {
    id!: string;
    pages: number = 1;
    pageSizes!: string;
    actors!: BaseActorModel[];
    documentStatus!: string;

}
export class BaseDocumentDetailsModel extends BaseDocumentModel {
    hash!: string;
    documentType!: string;
    /**
     * NEW bytesize
     */
    fileSize!: number;
}
export class DocumentModel extends BaseDocumentDetailsModel {
    name!: string;
    filetype!: string;
    progress: number = 0;
    containsPreviousSignatures: boolean = false;
    preloadedPages!: PreloadedPages[];
    dossierIndex!: number;
    error?: string;
    uploadProgress: number = 100;
    workflowPlaceholderId?: number | null;
    filename!: string;
    thumbnails!: Thumbnail[];
    checksum!: string | null;
    /**
     * OLD bytesize
     */
    documentSize!: number | null;

}

export class PageSize {
    X!: number;
    Y!: number;
}

export class PreloadedPagesByDocument {
    documentId!: string;
    preloadedPages!: PreloadedPages[];
}

export class PreloadedPages {
    pageId!: number;
    pageUrl: SafeUrl | null = null;
}
export class Thumbnail {
    PageId!: number;
    ThumbnailUrl: SafeUrl | null = null;
}
export class DocumentInfoForToast {
    Guid!: string;
    Name!: string;
}
export class DocumentIsLockedModel extends DocumentInfoForToast {
    Seconds!: number;
}
